import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "relative",
  ref: "dropdownContainer"
}
const _hoisted_2 = { class: "py-1 max-h-64 overflow-y-auto" }
const _hoisted_3 = {
  key: 0,
  class: "px-4 py-2 text-sm text-gray-500 text-center"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "inline-flex items-center gap-x-1.5 p-1 rounded-full bg-gray-100 text-xs font-medium text-gray-600" }
const _hoisted_6 = { class: "flex-1 min-w-0" }
const _hoisted_7 = { class: "font-medium truncate" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs text-gray-500 truncate"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
      class: "w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
    }, [
      _cache[3] || (_cache[3] = _createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
        })
      ], -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('files.context_menu.add_to_scene')) + " ", 1),
      (_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["w-4 h-4 ml-auto", { 'rotate-180': _ctx.isOpen }]),
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 9l-7 7-7-7"
        }, null, -1)
      ]), 2))
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "absolute left-2 z-10 mt-1 w-56 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.folders.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('files.context_menu.no_scenes')), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableFolders, (folder) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: folder.id,
                    onClick: ($event: any) => (_ctx.selectScene(folder)),
                    class: "w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-3"
                  }, [
                    _createElementVNode("span", _hoisted_5, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: "size-1.5",
                        style: _normalizeStyle({fill: folder.color}),
                        viewBox: "0 0 6 6",
                        "aria-hidden": "true"
                      }, _cache[4] || (_cache[4] = [
                        _createElementVNode("circle", {
                          cx: "3",
                          cy: "3",
                          r: "3"
                        }, null, -1)
                      ]), 4))
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(folder.title), 1),
                      (folder.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(folder.description), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_4))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}